import * as React from 'react';
import styled from 'styled-components';
import { withProps } from '../../../../theme/styled-components';
import { rem } from 'polished';
import { FlexBetween } from '../../Flexbox/Flexbox';
import { Variant as VariantTypes } from '../types';
import { formatPrice } from '../../../../utilities';

export interface Props {
  item: VariantTypes;
  name: string;
  onClickItem: (item: VariantTypes) => void;
}

interface ProductVariantValueProps {
  available: boolean;
}

export default class ProductVariantValues extends React.Component<Props> {
  render() {
    const { item, onClickItem, name } = this.props;
    return (
      // tslint:disable-next-line
      <ProductVariantValue onClick={() => this.props.onClickItem(item)}>
        <ProductVariantValueTextWrapper>
          <ProductVariantValueText>{name}</ProductVariantValueText>
          <ProductVariantValueAvailability>
            {item.is_on_stock === 1 ? (
              <OnStockMsg>
                {item.availability.avail_uniqid} {item.on_stock_count}{' '}
                {item.units}{' '}
              </OnStockMsg>
            ) : (
              <NotOnStockMsg> {item.availability.avail_uniqid} </NotOnStockMsg>
            )}
          </ProductVariantValueAvailability>
        </ProductVariantValueTextWrapper>
        <ProductVariantValuePrice available={item.is_on_stock === 1}>
          {formatPrice(item.final_price || 0, item.currency.name, 2)}
        </ProductVariantValuePrice>
      </ProductVariantValue>
    );
  }
}

const OnStockMsg = styled.span`
  font-size: ${({ theme }) => theme.fontSizeXXS};
  color: ${({ theme }) => theme.colors.successColor};
`;

const NotOnStockMsg = styled.span`
  font-size: ${({ theme }) => theme.fontSizeXXS};
  color: ${({ theme }) => theme.colors.inactiveFontColor};
`;

const ProductVariantValuePrice = withProps<ProductVariantValueProps>()(
  styled.div,
)`
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-weight: 700;
  color: ${({ available, theme }) =>
    available
      ? `${theme.colors.textPrimary}`
      : `${theme.colors.inactiveFontColor}`};
`;
const ProductVariantValueAvailability = styled.div`
  font-size: ${({ theme }) => theme.fontSizeXXS};
`;

const ProductVariantValueText = styled.div`
  font-size: ${({ theme }) => theme.fontSizeXS};
  text-decoration: none;
  transition: text-decoration 0.3s ease;
`;
const ProductVariantValueTextWrapper = styled.div``;

const ProductVariantValue = styled(FlexBetween)`
  border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.borderColor};
  padding: ${rem(10)} ${rem(15)};
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    ${ProductVariantValueText} {
      text-decoration: underline;
    }
  }
`;
